import React from 'react';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useForm } from '../../../../shared/hooks/form-hook';
import Input from '../../../../shared/components/FormElements/input';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './AddNews.css'
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';

const AddNews = () => {

  const history = useHistory();

    const [formState, inputHandler ] = useForm(
        {
            title: {
              value: '',
              isValid: false
            },
            content: {
              value: '',
              isValid: false
            },
            image: {
                value: null,
                isValid: false
            },
            url: {
              value: '',
              isValid: false
            },
            createdAt: {
              value: '',
              isValid: false
            }
        },
        false
    );

   

    const addHandler = async (event) => {
        event.preventDefault();

        try {
          const formData = new FormData();
          formData.append('title', formState.inputs.title.value);
          formData.append('content', formState.inputs.content.value);
          formData.append('image', formState.inputs.image.value);
          formData.append('url', formState.inputs.url.value);
         

          const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/news', {
            method: 'POST',
            body: formData
          });
         
        
          const responseData = await response.json();
          console.log(responseData)
          history.push('/');
        } catch (err) {
          console.log(err)
        }
        // window.success('Successfully');
    }

    return (  
        <main className='news-container'> 
          <Link to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></Link>
            <h1>Шинэ мэдээ нэмэх</h1>  
          
            <div className='news-form-container'> 
            
            <form onSubmit={addHandler} className='news-form'>
                <Input 
                  element="input" 
                  id="title" 
                  type="text" 
                  label="Title"
                  autoComplete='off' 
                  placeholder='Гарчиг'
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="textarea"
                  id="content" 
                  type="text" 
                  label="Article"
                  autoComplete='off' 
                  placeholder='Бичвэр'
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a your article' 
                  onInput={inputHandler}
                />
                
                <ImageUpload 
                  id='image'
                  onInput={inputHandler}
                />

                <Input 
                  element="input" 
                  id="url" 
                  type="url" 
                  label="Url (Optional)"
                  autoComplete='off' 
                  placeholder='link оруулна уу'
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid your first name.' 
                  onInput={inputHandler}
                />
                <Button type="submit" disabled={!formState.isValid} variant='contained' style={{marginTop: '20px'}}>Publish</Button>
            </form>
            </div> 
        </main>  
    )
}

export default AddNews;